import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.559 18h-7.5a1.5 1.5 0 0 0-1.5 1.5V21a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5m0 3h-7.5v-1.5h7.5zm5.78-10.28-9-9a.75.75 0 0 0-1.06 0l-9 9a.75.75 0 0 0 .53 1.28h3.75v3a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5v-3h3.75a.75.75 0 0 0 .53-1.28m-5.78-.22V15h-7.5v-4.5h-3.44l7.19-7.19 7.19 7.19z"
    }, null, -1)
  ]))]))
}
export default { render: render }